export default __webpack_public_path__ + "static/media/aeth.0aedc8c7.svg";